// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"a52b7acf","703":"db567b1f","787":"e9cd2782"}[chunkId] + ".chunk.js";
};